import React       from 'react';
import HiddenInput from 'pu-react/components/HiddenInput';

const RowSelected = (props) => {
  const name = 'row_selected';
  //let value = props.parameters.get(name);
  let value = props.parameters[name];
  if (value !== undefined && typeof value === 'number') {
    value = value.toString();
  }
  return (
    <HiddenInput name={name} value={value === undefined ? '' : value} />
  );
};

export default RowSelected;
